import { TextField, withDatasourceCheck } from "@sitecore-jss/sitecore-jss-nextjs";
import { ComponentProps } from "lib/component-props";
import { SocialMediaCard, SocialMediaItemFields } from "./SocialMediaCard";

type SocialMediaFields = {
  Items?: { fields: SocialMediaItemFields; id: string }[];
  Title?: TextField;
};

type SocialMediaPageContentProps = ComponentProps & {
  fields: SocialMediaFields;
};

const SocialMediaPageContent = (props: SocialMediaPageContentProps): JSX.Element => {
  const { Title, Items } = props?.fields || {};

  return (
    <section aria-labelledby={Title?.value ? "social-media-title" : undefined}>
      {/* heading part */}
      {Title?.value && (
        <header className="bg-primary-50 pb-10">
          <h1 id="social-media-title" className="responsive font-bold text-3xl md:text-4xl md:font-semibold ">
            {Title.value}
          </h1>
        </header>
      )}

      {/* content */}
      {Items && Items?.length > 0 && (
        <div className="responsive py-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {Items.map((card) => (
            <SocialMediaCard key={card?.id} {...card?.fields} />
          ))}
        </div>
      )}
    </section>
  );
};

export default withDatasourceCheck()<SocialMediaPageContentProps>(SocialMediaPageContent);
